import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import { connect } from 'react-redux';
import { saveNewChitChatThread } from 'actions/chitchat';
import moment from 'moment';
import Thread from 'components/ChitChat/Thread';
import NewPostBox from 'components/ChitChat/NewPostBox';
import SimpleDialog from 'components/SimpleDialog';
import { CHIT_CHAT_RELATIONSHIPS, CHIT_CHAT_TYPES } from 'common/chitChatTypes';
import {
  Grid, Alert,
  Snackbar,
  AlertTitle,
} from '@mui/material';
import { fetchChitChat } from 'actions/chitchat';
import {
  getBooking,
} from 'actions/events';
import LoaderOverlay from 'components/LoaderOverlay';
import { bookingReceived } from 'actions/events';

const styles = theme => ({
  chitChat: {
    display: 'flex',
    flexDirection: 'column',
    width: '75%',
    flex: '1 1 auto',
    margin: 'auto',
  },
  postsContainer: {
    flexGrow: 1,
  },
  timelineHeader: {
    flexGrow: 1,
    // height: 33,
    // lineHeight: '33px',
    verticalAlign: 'middle',
    paddingLeft: 33,
    fontSize: 17,
  },
  postHeader: {
    flexGrow: 1,
    marginTop: 20,
    fontSize: 14,
  },
  postsHeader: {
    marginTop: 20,
    fontSize: 14,
  },
  filterTimeline: {
    width: '100%',
    fontSize: 16,
    verticalAlign: 'middle',
    padding: '6px 8px 8px 33px',
  },
  messagesSection: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 150,
    // height: '100%',
    padding: '0 20px 8px',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    flexGrow: 1,
    marginBottom: 26,
  },
});

class ChitChat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newPost: {},
      isPollingExpired: false,
      loaderSaveNewPost: false,
      showToastMessage: false,
      toastMessageType: 'success',
      errorMessageText: '',
    };

    this.chitChatRelationship = CHIT_CHAT_RELATIONSHIPS.booking;
    this.errorDialog = React.createRef();
  }

  componentDidMount() {
    this.pollingInterval = null;
    this.startPolling();
  }

  componentWillUnmount() {
    this.stopPolling();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.bookingId !== this.props.bookingId) {
      this.refreshChitChat();
    }
  }

  pollForNewMessages = () => {
    const { isPollingExpired } = this.state;
    const refreshInterval = window.env.REACT_APP_CHITCHAT_REFRESH_INTERVAL || 10000;

    if (!isPollingExpired) {
      console.log('Polling... (every ', refreshInterval, 'ms)');
      this.refreshChitChat();
      setTimeout(this.pollForNewMessages, refreshInterval);
    }
  };

  startPolling = () => {
    const idleLimit = 10800000; // 3 hours

    this.pollForNewMessages();
    setTimeout(this.stopPolling, idleLimit);
  };

  stopPolling = () => {
    console.log('STOP polling');
    this.pollForNewMessages = null;
    this.setState({ isPollingExpired: true });
  };

  refreshChitChat = async () => {
    const { eventLinkId, booking } = this.props;

    await this.props.getBooking(eventLinkId, booking);

    // fetchChitChat(eventLinkId, eventLinkId);
  };

  saveNewPost = () => {
    const { newPost } = this.state;
    const { saveNewChitChatThread, eventLinkId } = this.props;

    this.setState({ loaderSaveNewPost: true });
    const post = {
      baseMessage: {
        subject: 'Post',
        content: newPost.message,
        time: moment().format(),
      },
      relationshipId: eventLinkId,
      chitChatRelationship: this.chitChatRelationship,
    };

    return saveNewChitChatThread(CHIT_CHAT_TYPES.post, post, eventLinkId)
      .then(() => {
        sessionStorage.setItem('overviewSelectedTab', '2');
        this.refreshChitChat();
        this.setState({ loaderSaveNewPost: false, showToastMessage: true, toastMessageType: 'success', errorMessageText: 'Your post has been added successfully.' });
      })
      .catch(() => {
        this.errorDialog.current.open('Something went wrong. Please try again.');
        this.setState({ loaderSaveNewPost: false, showToastMessage: true, toastMessageType: 'error', errorMessageText: 'Something went wrong. Please try again.' });
      }
      );/*
    return saveNewChitChatThread(CHIT_CHAT_TYPES.post, post ,eventLinkId )
      .then(this.refreshChitChat)
      .catch(() => this.errorDialog.current.open('Something went wrong. Please try again.'));*/
  };

  handleChange = event => {
    const { target: { value, name } } = event;

    const newPost = {
      ...this.state.newPost,
      [name]: value,
    };

    this.setState({ newPost });
  };

  onAdd = () => {
    const { newPost } = this.state;

    if (!!newPost.message) {
      this.saveNewPost()
        .then(() => {
          this.setState({ newPost: {} });
          this.refreshChitChat();
        })
        .catch(() => this.errorDialog.current.open('Something went wrong. Please try again.'));
    } else {
      return this.errorDialog.current.open('Please include a message.');
    }
  };

  onShowComments = message => () => {
    const { booking } = this.props;

    if (!booking?.eventDetails?.chitChat) {
      return;
    };

    // Update the flag for the correct thread
    const updatedChitChat = booking.eventDetails.chitChat.map(thread =>
      thread.id === message.id
        ? { ...thread, showComments: !thread.showComments }
        : thread
    );

    // Create a new booking object with updated chitChat
    const updatedBooking = {
      ...booking,
      eventDetails: {
        ...booking.eventDetails,
        chitChat: updatedChitChat,
      },
    };

    // Dispatch the update to Redux
    this.props.bookingReceived(updatedBooking);
  };

  render() {
    // threads
    const { classes, booking } = this.props;
    const { newPost } = this.state;

    return (
      <div className={classes.chitChat}>
        <Grid container={true} spacing={1}>

          <Grid item={true} xs={12} sm={12} md={12} className={classes.postsContainer}>
            {/* <div className={classes.postHeader}>
              Post
            </div> */}
            <LoaderOverlay isLoading={this.state.loaderSaveNewPost}>
              <NewPostBox
                newPost={newPost}
                handleChange={this.handleChange}
                onAdd={this.onAdd}
              />
            </LoaderOverlay>

          </Grid>
          <Grid item={true} xs={12} sm={12} md={12} className={classes.messagesSection}>
            <Grid container={true} spacing={2}>
              <Grid item={true} xs={12} sm={12} md={12} className={classes.timelineHeader}>
                {/* <div className={classes.postsHeader}>
                  Posts
                </div> */}
              </Grid>
              {booking && booking.eventDetails && booking.eventDetails.chitChat && booking.eventDetails.chitChat.map((thread, index) => {
                const uniqueKey = `${thread.id}-${index}`;

                return (
                  <Grid item={true} xs={12} sm={12} md={12} key={uniqueKey}>
                    <Thread
                      thread={thread}
                      key={uniqueKey}
                      onCommentSent={this.refreshChitChat}
                      chitChatRelationship={this.chitChatRelationship}
                      onShowComments={clickedThread => this.onShowComments(clickedThread)}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
          <SimpleDialog onlyOkayButton={true} innerRef={this.errorDialog} />

        </Grid>
        <Snackbar open={this.state.showToastMessage} autoHideDuration={6000} onClose={() => this.setState({ showToastMessage: false })}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
          <Alert severity={this.state.toastMessageType}>
            <AlertTitle>{this.state.toastMessageType}</AlertTitle>
            {this.state.errorMessageText}
          </Alert>
        </Snackbar>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    api: {
      chitChat: {
        threads,
      },
    },
  } = state;

  return {
    threads,
    eventLinkId: state.caterease.catereaseCP,
  };
};

const mapDispatchToProps = {
  fetchChitChat,
  getBooking,
  saveNewChitChatThread,
  bookingReceived,
};

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(ChitChat));
